<template>
  <v-navigation-drawer class="overflow-scroll" :width="$vuetify.breakpoint.xs ? '100%' : '400'" v-model="sideSheet" fixed right temporary>
    <component :is="isComponent"></component>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      sideSheet: false,

      accountInfo: "account-info-form",
      personalInfo: "personal-info-form",
      locationInfo: "location-info-form",
      changePassword: "change-password-form",
      contactInfo: "contact-info-form"
    }
  },

  components: {
    "account-info-form": require("../myAccount/profileForms/accountInfoForm").default,
    "personal-info-form": require("../myAccount/profileForms/personalInfoForm").default,
    "location-info-form": require("../myAccount/profileForms/locationInfoForm").default,
    "change-password-form": require("../myAccount/profileForms/changePasswordForm").default,
    "contact-info-form": require("../myAccount/profileForms/contactInfoForm").default
  },

  watch: {
    sideSheetIsOn() {
      this.sideSheet = this.sideSheetIsOn
    },

    sideSheet() {
      !this.sideSheet &&
        (() => {
          this.$store.dispatch("SideSheet/resetComponent")
          this.$store.dispatch("SideSheet/toggleSideSheet", { isOn: false })
        })()
    }
  },

  computed: {
    sideSheetIsOn() {
      return this.$store.getters["SideSheet/isOn"]
    },

    isComponent() {
      return this.$store.getters["SideSheet/isComponent"]
    },

    profileForms() {
      return this.$store.getters["Profile/profileForms"]
    }
  },

  created() {
    this.sideSheet = this.sideSheetIsOn
  }
}
</script>

<style></style>
